import { CalendarDays, CheckCheck, Loader2 } from 'lucide-react'

import { Button } from '@/modules/shared/components/ui/button'
import {
	Form,
	FormControl,
	FormField,
	FormItem,
	FormLabel,
} from '@/modules/shared/components/ui/form'
import { Textarea } from '@/modules/shared/components/ui/textarea'
import { useSummary } from './use-summary.hook'
import { SummaryCardComponent } from './summary-card.component'
import { ModalSignatureComponent } from './signature-modal/modal-signature.component'
import { ModalScheduleComponent } from './schedule-modal/modal-schedule.component'


export function SummaryComponent() {
	const {
		form,
		isViewOrder,
		fieldsGroup,
		jsonOrderForm,
		isSavingOrder,
		handleSaveOrder,
		handleChangeValues,
		setOpenModalScheduleAfterSave,
	} = useSummary()

	return (
		<div>
			<div className="flex flex-col gap-4 md:flex-row">
				<SummaryCardComponent
					jsonOrderForm={jsonOrderForm}
					fieldsGroup={fieldsGroup.defaultFieldsGroup1}
				/>
				<SummaryCardComponent
					jsonOrderForm={jsonOrderForm}
					fieldsGroup={fieldsGroup.defaultFieldsGroup2}
				/>
				<SummaryCardComponent
					jsonOrderForm={jsonOrderForm}
					fieldsGroup={fieldsGroup.defaultFieldsGroup3}
				/>
			</div>

			<Form {...form}>
				<FormField
					control={form.control}
					name="observation"
					render={({ field }) => (
						<FormItem>
							<FormLabel>Observação</FormLabel>
							<FormControl>
								<Textarea
									{...field}
									spellCheck={false}
									placeholder="Digite aqui sua observação..."
									className="resize-y"
									onKeyUp={(e) =>
										handleChangeValues('obsPedido', e.currentTarget.value)
									}
									onKeyDown={(e) => {
										const pressedKey = e.key
										if (
											pressedKey === "'" ||
											pressedKey === '"' ||
											pressedKey === '`'
										) {
											e.preventDefault()
										}
									}}
									disabled={isViewOrder}
								/>
							</FormControl>
						</FormItem>
					)}
				/>
			</Form>

			{!isViewOrder && (
				<div className="flex flex-1 justify-end mt-6 space-x-2">
					<Button
						className="bg-blue-500 hover:bg-blue-700 fixed bottom-40 right-2 md:static md:rounded-md md:h-auto md:flex md:w-auto rounded-full h-14 w-14"
						onClick={() => {
							setOpenModalScheduleAfterSave(true)
							handleSaveOrder()
						}}
						disabled={isSavingOrder}
					>
						{isSavingOrder ? (
							<Loader2 className=" md:mr-2 animate-spin" />
						) : (
							<CalendarDays
								size={20}
								className="md:mr-2 size-20 md:size-auto"
							/>
						)}
						<p className="hidden md:flex">Finalizar e Agendar</p>
					</Button>
					<Button
						className="bg-green-600 hover:bg-green-700 fixed bottom-24 right-2 md:static md:rounded-md md:h-auto md:flex md:w-auto rounded-full h-14 w-14"
						onClick={() => {
							handleSaveOrder()
						}}
						disabled={isSavingOrder}
					>
						{isSavingOrder ? (
							<Loader2 className=" md:mr-2 animate-spin" />
						) : (
							<CheckCheck size={20} className="md:mr-2 size-24 md:size-auto" />
						)}
						<p className="hidden md:flex">Finalizar</p>
					</Button>
				</div>
			)}
			<ModalSignatureComponent />
			<ModalScheduleComponent />
		</div>
	)
}
